import formComponent from '@/util/proto/formComponent'

export default {
  extends: formComponent ,

  props:['companyId','value'],
  data() {
    return {
      innerValue:[]
    }
  },
  created(){
    if( this.value ){
      this.innerValue = this.value.split(';')
    }
    if(this.companyId){
      this.query()
    }
  },
  methods:{
    query(){
      this.$request.company(this.companyId).then(resp => {
        if(resp.code){
          this.$Message.error(resp.msg)
        }else{
          this.innerValue = (resp.data.files || []).filter(i => i.fileType == 21).map(i => i.filePath)
        }
      })  
    },
    save(){
      let params = {id:this.companyId , netPhotos:this.innerValue.join(';') }
      this.$request.compayUpdatePhotoByOrg(params).then(resp => {
        if(resp.code){
          this.$Message.error(resp.msg)
        }else{
          this.$Message.success('修改完成')
          this.$emit('ok')
        }
      })  
    },
  },
  render(){
    const { loading , save } = this
    return (
      <div>
        <div class="modal-body">
          <sl-upload public={true} v-model={this.innerValue} type="21" limit={6}>支持格式：jpg, png, bmp , gif。最多6张。</sl-upload>
        </div>
        <div class="modal-footer">
          <Button loading={loading} on-click={save} type="primary">确定</Button>
        </div>
      </div>
    )
  }
}